<div class="header-container">
  <div class="tabs-container">
    <div
      class="tab"
      *ngFor="let tab of tabs"
      [class.active]="selectedToggle === tab.id"
      (click)="selectTab(tab.id)"
    >
      {{ tab.label | translate }}
    </div>
  </div>

  <div class="filter-options">
    <mat-checkbox
      [(ngModel)]="showOnlyTodayTasks"
      (change)="filterTasksByDate()"
      class="today-tasks-filter"
    >
      {{ 'COMPONENT.PAGE_ORGA.show_only_today_tasks' | translate }}
    </mat-checkbox>
  </div>
</div>

<div [ngSwitch]="selectedToggle" class="content-container">
  <!-- Tasks tab -->
  <div *ngSwitchCase="'tasks'" class="tasks-wrapper">
    <ng-container *ngIf="filteredTasks && filteredTasks.length > 0; else emptyTasks">
      <app-orga-tabs-tasks
        [tasks]="filteredTasks"
        (clickOnTask)="onClickOnTask($event)"
      ></app-orga-tabs-tasks>
    </ng-container>

    <ng-template #emptyTasks>
      <div class="empty-state-container">
        <mat-icon class="empty-state-icon">assignment</mat-icon>
        <div class="empty-state-message">
          {{ 'COMPONENT.PAGE_ORGA.no_workflows_found' | translate }}
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Medical orders tab -->
  <div *ngSwitchCase="'medical_orders'" class="tasks-wrapper">
    <ng-container *ngIf="false; else emptyMedicalOrders"> </ng-container>

    <ng-template #emptyMedicalOrders>
      <div class="empty-state-container">
        <mat-icon class="empty-state-icon">assignment</mat-icon>
        <div class="empty-state-message">
          {{ 'COMPONENT.PAGE_ORGA.no_workflows_found' | translate }}
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Diagnostic findings tab -->
  <div *ngSwitchCase="'diagnostic_findings'" class="tasks-wrapper">
    <ng-container *ngIf="false; else emptyDiagnostics"> </ng-container>

    <ng-template #emptyDiagnostics>
      <div class="empty-state-container">
        <mat-icon class="empty-state-icon">assignment</mat-icon>
        <div class="empty-state-message">
          {{ 'COMPONENT.PAGE_ORGA.no_workflows_found' | translate }}
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Default case  -->
  <div *ngSwitchDefault class="tasks-wrapper">
    <ng-container *ngIf="tasks && tasks.length > 0; else emptyDefaultTasks">
      <app-orga-tabs-tasks
        [tasks]="tasks"
        (clickOnTask)="onClickOnTask($event)"
      ></app-orga-tabs-tasks>
    </ng-container>

    <ng-template #emptyDefaultTasks>
      <div class="empty-state-container">
        <mat-icon class="empty-state-icon">assignment</mat-icon>
        <div class="empty-state-message">
          {{ 'COMPONENT.PAGE_ORGA.no_workflows_found' | translate }}
        </div>
      </div>
    </ng-template>
  </div>
</div>
